import CustomAutocomplete from 'designer/component/element/Autocomplete'
import ControlWrapper from './ControlWrapper'

const AutocompleteControl = (props) => {
  return <ControlWrapper {...props} Component={CustomAutocomplete} />
}

export default AutocompleteControl
